module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//20.jpg?9942c4d1dd7c0a22d46b58e5e7d14844";